// extracted by mini-css-extract-plugin
module.exports = {"value":"number_group_list_value__1rRiX","editing":"number_group_list_editing__3T_5s"};